import type {
    Category,
    ListParentCategoryRes,
    ListProductTemplateByCategoryRes,
    RetrieveCategory,
    RetrieveCategoryWithDepth,
} from '@ortros/stoux-lib'
import { AxiosResponse } from 'axios'
import type { HttpResponse } from 'nexus-res'

import axios from '@/core/axios'

export default class CategoryService {
    /**
     * # Get all parent categories
     */

    public static async getAllParentCategories(): Promise<
        HttpResponse<ListParentCategoryRes>
    > {
        const query: AxiosResponse<
            HttpResponse<ListParentCategoryRes>,
            any
        > = await axios.get<HttpResponse<ListParentCategoryRes>>('/categories')
        return query.data
    }

    /**
     * Get category info by handle
     */
    public static async getCategoryByHandle(handle: string) {
        const { data } = await axios.get<HttpResponse<RetrieveCategory>>(
            `/categories/${handle}`,
        )
        return data
    }

    /**
     * # Get all products from a specific category
     */
    public static async getAllProductTemplates(
        categoryHandle: string,
        offset: number = 0,
        limit: number = 10,
    ) {
        const { data } = await axios.get<
            HttpResponse<ListProductTemplateByCategoryRes>
        >(`/categories/${categoryHandle}/templates`, {
            params: {
                offset,
                limit,
            },
        })
        return data
    }

    /**
     * # Get all parent categories with tree
     *
     */
    public static async getAllParentCategoriesWithTree() {
        const { data } =
            await axios.get<HttpResponse<Category[]>>(`/categories/tree`)
        return data
    }

    public static async getCategoryTree(handle: string) {
        const { data } = await axios.get<
            HttpResponse<RetrieveCategoryWithDepth[]>
        >(`/categories/${handle}/tree`)
        return data
    }
}
